<template>
  <div class="box">
    <RadioButtons kind="lang" v-model="lang" mandatory/>
    <b-field label="Idegen">
      <b-input id="inp1" v-model="orig" />
    </b-field>
    <b-field label="Magyar">
      <b-input id='inp2' v-model="hun" type="textarea" @focus="get_transl" />
    </b-field>
    <b-field v-if="lang=='eng'" label="Webster">
      <div v-html="webster"></div>
    </b-field>
    <b-button @click="_click">Mentés</b-button>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="true" />
  </div>
</template>

<script>
import RadioButtons from '@/components/RadioButtons.vue'
import DictSvc from '@/services.js'

export default {
  name: 'NewTab',
  props: {
    kind: String,
    value: String
  },
  data: function() {
    return {
      lang : "ita",
      orig : "",
      hun : "",
      transl : "",
      mono : "",
      example : "",
      isLoading : false
    }
  },
  computed: {
    webster() {
      return this.mono.replace(/\n/g, '<br />')
    }
  },
  components: {
    RadioButtons
  },
  watch: {
    lang: 'set_tag'
  },
  methods: {
    set_tag: function() {
      document.cookie = 'lang='+this.lang+'; path=/';
      if (this.orig == '') document.getElementById('inp1').focus()
    },
    _click: function () {
      if (!(this.orig == '' || this.hun == '')) {
        DictSvc.save(this.lang, this.orig, this.hun, this.transl, this.mono, this.example)
        .then(() => {
          this.orig = ''
          this.hun = ''
          this.example = ''
          this.mono = ''
          document.getElementById('inp1').focus();
        })
      }
    },
    get_transl() {
      if (['eng', 'ger', 'ita', 'pol'].includes(this.lang)) {
        if (this.orig != '' && this.hun == '') {
          this.isLoading = true
          DictSvc.getTransl(this.lang, this.orig)
          .then((myJSON) => {
            this.isLoading = false
            this.hun = myJSON['hun']
            this.transl = myJSON['hun']
            if (myJSON['gender']) {
              this.orig = myJSON['gender'] + ' ' + this.orig
            }
          })
          .catch(() => {this.isLoading = false});
        }
      if (this.lang == 'eng' && this.orig != '') {
          DictSvc.getWebster(this.orig)
          .then((myJSON) => {
            this.mono = myJSON['mono']
            this.example = myJSON['example']
          })
        }
      }
    }
  },
  mounted: function() {
    if (document.cookie != '') {
      var _d = {};
      for (const a of document.cookie.split(';')){
        var e = a.split('=');
        _d[e[0].trim()] = e[1].trim();
      }
      this.lang = _d['lang'];
    }
  }
}
</script>

<style scoped>
</style>
